import React from "react";
import DateControl from "./Date";
import { capitalize } from "lib/utils/socialtravel";

export default class SeparateDateRangeControl extends React.PureComponent {
  render() {
    const { name, onChange, value, ...rest } = this.props;
    const [start, end] = value !== null ? value : [null, null];
    return (
      <div className="field inline u-SeparateDateRangeControl">
        <DateControl
          value={start}
          onChange={(start) => onChange([start, end])}
          {...rest}
          placeholder={capitalize(I18n.t("base.from"))}
          max={end || undefined}
        />

        <div className="DateRangePickerInput__arrow">
          <svg viewBox="0 0 1000 1000">
            <path d="M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z"></path>
          </svg>
        </div>

        <DateControl
          value={end}
          onChange={(end) => onChange([start, end])}
          {...rest}
          placeholder={capitalize(I18n.t("base.to"))}
          min={start || undefined}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/SeparateDateRange.jsx